import { Route } from '@/services/routes/route.vm';

export type RoutesState = Record<string, Route>;

export const routesInitialState: RoutesState = {};

export enum RoutesActionTypes {
  LOAD_ROUTES = 'LOAD_ROUTES',
  UPDATE_ROUTE = 'UPDATE_ROUTE',
  ADD_OR_REPLACE_ROUTE = 'ADD_OR_REPLACE_ROUTE',
  DELETE_ROUTE = 'DELETE_ROUTE',
}

export interface RouteAction<T = any> {
  type: RoutesActionTypes;
  payload?: T;
}

const updateStateByAction: Record<
  RoutesActionTypes,
  (state: RoutesState, action: RouteAction) => RoutesState
> = {
  [RoutesActionTypes.LOAD_ROUTES]: (state, action: RouteAction<Route[]>) => {
    const { payload } = action;
    if (!payload) return state;
    const orderedRoutesList = [...payload].sort((a, b) => {
      return a.order - b.order;
    });
    const orderedRouteContents = orderedRoutesList.map((route) => {
      return {
        ...route,
      };
    });
    const newState = orderedRouteContents.reduce((acc, route) => {
      acc[route.id] = route;
      return acc;
    }, {} as RoutesState);
    return { ...state, ...newState };
  },
  [RoutesActionTypes.UPDATE_ROUTE]: (state, action: RouteAction<{ id: string; route: Partial<Route> }>) => {
    const { payload } = action;
    if (!payload) return state;
    const { id, route } = payload;
    return {
      ...state,
      [id]: {
        ...state[id],
        ...route,
      },
    };
  },
  [RoutesActionTypes.ADD_OR_REPLACE_ROUTE]: (state, action: RouteAction<Route>) => {
    const { payload } = action;
    if (!payload) return state;
    return {
      ...state,
      [payload.id]: payload,
    };
  },
  [RoutesActionTypes.DELETE_ROUTE]: (state, action: RouteAction<Route['id']>) => {
    const { payload } = action;
    if (!payload) return state;
    const { [payload]: deleted, ...rest } = state;
    return rest;
  },
};

export const routesDataReducer = (state: RoutesState, action: RouteAction) => {
  const { type: actionType } = action;
  const updateState = updateStateByAction[actionType];
  return updateState ? updateState(state, action) : state;
};
